import type { OnboardingQuestionnaireState } from '../../types';

export function decrementPendingReferralInfoUpdates(state: OnboardingQuestionnaireState) {
  state.pendingReferralInfoUpdateCount = Math.max(state.pendingReferralInfoUpdateCount - 1, 0);
  state.updateReferralInfoLoading = state.pendingReferralInfoUpdateCount > 0;
}
